import { render, staticRenderFns } from "./GroupsView.vue?vue&type=template&id=dc38b93c&scoped=true&"
import script from "./GroupsView.vue?vue&type=script&lang=js&"
export * from "./GroupsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc38b93c",
  null
  
)

export default component.exports